import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { TextField, Row, Button, Field, Label, CollapsiblePanel, ButtonLinkExternal } from '../../generic'
import { ToolTip } from '../../forms/eventFormComponents';
import TextInput from '../../generic/fields/TextInput'
import Select from '../../generic/fields/Select'

class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showChangePassword: false
    }
    this.handleShowChangePassword = this.handleShowChangePassword.bind(this)
  }

  handleShowChangePassword() {
    this.setState({
      showChangePassword: !this.state.showChangePassword
    })
  }

  render() {
  	const { userEvent, currentUser, onChange } = this.props
    console.log("password is ", currentUser.password)
    console.log("repeat password is ", currentUser.repeat_password)
  	return (
    	<React.Fragment>
        <h1 style={{marginBottom: '30px'}}>Complete Your On the Table Account</h1>
    		<h2 style={{marginBottom: '20px'}}>Required Information</h2>
	    	<Row className="twoCol">
	    		<Field name="currentUser[firstname]" error={false} required={true}>
	    			<Label value="First Name" />
	    			<TextInput autoFocus="true" value={currentUser.firstname} onChange={onChange} />
	    		</Field>
	    		<Field name="currentUser[lastname]" error={false} required={true}>
	    			<Label value="Last Name" />
	    			<TextInput value={currentUser.lastname} onChange={onChange} />
	    		</Field>
    		</Row>
    		<Row style={{marginBottom: '35px'}} className="twoCol">
	    		<Field name="currentUser[email]" error={false} required={true}>
	    			<Label value="Email" />
	    			<TextInput value={currentUser.email} onChange={onChange} />
	    		</Field>
	    	</Row>

    		<h2 style={{marginBottom: '20px'}}>Optional Information</h2>
	    	<Row className="twoCol">
	    		<Field name="userEvent[organization_name]" error={false}>
	    			<Label value="Organization Name" />
	    			<TextInput value={userEvent.organization_name} onChange={onChange} />
	    		</Field>
          <Field name="userEvent[phone_number]" error={false}>
            <Label value="Phone" />
            <TextInput value={userEvent.phone_number} onChange={onChange} />
          </Field>
	    	</Row>
        <Row className="twoCol">
          <div>
            <Field name="userEvent[referral]" error={false}>
              <Label value="How did you hear about On the Table BC?" />
              <Select value={userEvent.referral || ""} onChange={onChange}>
                <option value="">- Please Choose -</option>
                <option value="Vancouver Foundation">Vancouver Foundation</option>
                <option value="Social Media">Social Media</option>
                <option value="Advertising">Advertising</option>
                <option value="Word of Mouth">Word of Mouth</option>
                <option value="Postcard">Postcard</option>
                <option value="Other (please specify)">Other (please specify)</option>
              </Select>
            </Field>
            {userEvent.referral === 'Other (please specify)' && (
              <Field name="userEvent[referral_other]" error={false}>
                <TextInput value={userEvent.referral_other} onChange={onChange} />
              </Field>
            )}
          </div>
        </Row>

        <Row style={{marginBottom: '35px'}} className="twoCol">
          <Field name="userEvent[capacity]" error={false}>
            <Label value="Approximately how many guests do you intend to invite?" />
            <Select value={userEvent.capacity || ""} onChange={onChange}>
              <option value="">- Please Choose -</option>
              <option value="1">12 or fewer</option>
              <option value="2">13 - 24</option>
              <option value="3">More than 24</option>
            </Select>
          </Field>
        </Row>

        <h2 style={{marginBottom: '20px'}}>Your Password</h2>
        <div style={{marginBottom: '35px'}}>
          <ButtonLinkExternal secondary onClick={this.handleShowChangePassword} style={{marginRight: "16px", marginBottom: "16px"}}>Change Your Password</ButtonLinkExternal>
          {this.state.showChangePassword && 
            <Row className="twoCol">
              <Field name="currentUser[password]" error={false}>
                <Label value="New Password" />
                <TextInput type="password" autoComplete="off" value={currentUser.password} onChange={onChange} />
              </Field>
              <Field name="currentUser[repeat_password]" error={false} hint={currentUser.password != currentUser.repeat_password && <div style={{color: 'red'}}>Passwords should match.</div>}>
                <Label value="Repeat Password" />
                <TextInput type="password" autoComplete="off" value={currentUser.repeat_password} onChange={onChange} />
              </Field>
            </Row>
          }
        </div>
    	</React.Fragment>
    )
  }
}

export default Profile
